/*
 * Prestige — Text Reveal on Scroll (Ekon-style)
 * -------------------------------------------------------------
 * Each word scrubs from muted -> clear as a reveal front tracks
 * scroll. Driven by a PERSISTENT requestAnimationFrame loop (never
 * depends on scroll-event frequency) so it is smooth everywhere,
 * including mobile / iOS momentum scroll. Per-frame work is skipped
 * for sections that are off-screen, so the idle cost is tiny.
 * Respects prefers-reduced-motion.
 */
(function () {
  if (window.__prestigeTextRevealInit) return;
  window.__prestigeTextRevealInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ANCHORS = { top: 0.2, middle: 0.55, bottom: 0.85 };
  var sections = [];

  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }
  function smooth(t) { return t * t * (3 - 2 * t); }

  function hexToRgb(h) {
    h = (h || '#888888').trim().replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var n = parseInt(h, 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function mix(c1, c2, t) {
    return 'rgb(' +
      Math.round(c1[0] + (c2[0] - c1[0]) * t) + ',' +
      Math.round(c1[1] + (c2[1] - c1[1]) * t) + ',' +
      Math.round(c1[2] + (c2[2] - c1[2]) * t) + ')';
  }

  function splitWords(el) {
    if (el.__trSplit) return el.__trWords;
    var text = el.textContent;
    el.textContent = '';
    var words = [];
    text.split(/(\s+)/).forEach(function (tok) {
      if (tok.trim() === '') { el.appendChild(document.createTextNode(tok)); return; }
      var span = document.createElement('span');
      span.className = 'tr-word';
      span.textContent = tok;
      el.appendChild(span);
      words.push(span);
    });
    el.__trSplit = true;
    el.__trWords = words;
    return words;
  }

  function build(el) {
    var d = el.dataset;
    var cfg = {
      anchor: ANCHORS[d.trTrigger] != null ? ANCHORS[d.trTrigger] : 0.55,
      speed: parseFloat(d.trSpeed) || 1,
      soft: parseFloat(d.trSoft) || 4,
      muted: hexToRgb(d.trMuted),
      hi: hexToRgb(d.trHi),
      blur: parseFloat(d.trBlur) || 0,
      rise: parseFloat(d.trRise) || 0,
      fade: d.trFade === 'true',
      fadeMin: d.trFadeMin != null ? parseFloat(d.trFadeMin) : 0.15
    };
    var words = [];
    el.querySelectorAll('[data-tr-text]').forEach(function (p) {
      words = words.concat(splitWords(p));
    });
    return { el: el, cfg: cfg, words: words, last: -1 };
  }

  function progress(S) {
    var r = S.el.getBoundingClientRect();
    var vh = window.innerHeight;
    var anchorPx = vh * S.cfg.anchor;
    var span = r.height * (1 / S.cfg.speed);
    return clamp((anchorPx - r.top) / (span || 1), 0, 1);
  }

  function paint(S) {
    var p = reduce ? 1 : progress(S);
    if (p === S.last) return;
    S.last = p;
    var N = S.words.length, soft = S.cfg.soft, c = S.cfg;
    for (var w = 0; w < N; w++) {
      var raw = reduce ? 1 : clamp((p * (N + soft) - w) / soft, 0, 1);
      var t = smooth(raw);
      var word = S.words[w];
      word.style.color = mix(c.muted, c.hi, t);
      word.style.filter = c.blur > 0 ? 'blur(' + ((1 - t) * c.blur).toFixed(2) + 'px)' : '';
      word.style.transform = c.rise > 0 ? 'translateY(' + ((1 - t) * c.rise).toFixed(1) + 'px)' : '';
      if (c.fade) word.style.opacity = (c.fadeMin + (1 - c.fadeMin) * t).toFixed(3);
    }
  }

  function inView(S, vh) {
    var r = S.el.getBoundingClientRect();
    return r.bottom > -vh * 0.35 && r.top < vh * 1.35;
  }

  function frame() {
    var vh = window.innerHeight;
    for (var i = 0; i < sections.length; i++) {
      // A single section throwing (bad data, a mid-scroll layout read, etc.)
      // must never kill the loop for every other reveal on the page.
      try {
        if (inView(sections[i], vh)) paint(sections[i]);
      } catch (err) {}
    }
    requestAnimationFrame(frame);
  }

  function collect() {
    sections = [];
    document.querySelectorAll('[data-text-reveal]').forEach(function (el) { sections.push(build(el)); });
  }

  function init() {
    collect();
    if (reduce) {
      for (var i = 0; i < sections.length; i++) { try { paint(sections[i]); } catch (err) {} }
      return;
    }
    requestAnimationFrame(frame);
    document.addEventListener('shopify:section:load', collect);
    document.addEventListener('shopify:section:unload', collect);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
